import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarSubTarefaModeloPayload, atualizarSubTarefaModeloPayload} from '../../interfaces/subTarefasModelos'


export function novaSubTarefaModelo (idTarefa: number, payload: cadastrarSubTarefaModeloPayload) {
    return BASEURLGESTTOR.post(`/subtarefas/modelo/${idTarefa}`, payload)
} 

export function listarSubtarefasModelos (idTarefa: string) {
    return BASEURLGESTTOR.get (`/subtarefas/modelo/${idTarefa}`)
}

export function atualizarSubTarefaModelo (idSubTarefa: number, payload: atualizarSubTarefaModeloPayload) {
    return BASEURLGESTTOR.patch(`/subtarefas/modelo/${idSubTarefa}`, payload)
}

export function deletarSubTarefaModelo (idSubTarefa: number) {
    return BASEURLGESTTOR.delete(`/subtarefas/modelo/${idSubTarefa}`)
}

